import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: ShippingState = {
    all: [],
    viewing: undefined,
};

const getters: GetterTree<ShippingState, RootState> = {
    all(state: ShippingState): Shipping[] {
        return state.all;
    },
};

const mutations: MutationTree<ShippingState> = {
    RESET(state: ShippingState) {
        state.all = [];
        state.viewing = undefined;
    },
    UPDATE_MODEL(state: ShippingState, payload: Shipping) {
        const index = state.all.findIndex((model: Shipping) => model.id === payload.id);

        if (index === -1) {
            state.all.push(payload);
        } else {
            state.all[index] = payload;
        }
    },
    SET_MODELS(state: ShippingState, payload: Shipping[]) {
        state.all = payload;
    },
    SET_VIEWING(state: ShippingState, payload: Shipping) {
        state.viewing = payload;
    },
};


const actions: ActionTree<ShippingState, RootState> = {
    index({ commit, rootState }) {
        return rootState.api.get(`shipping-methods`, { withCredentials: true })
            .then((response: { data: Shipping }) => {
                commit('SET_MODELS', response.data);

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    read({ commit, rootState }, payload: { id: number }) {
        return rootState.api.get(`shipping-methods/${payload.id}`, { withCredentials: true })
            .then((response: { data: Shipping }) => {
                commit('UPDATE_MODEL', response.data);

                commit('SET_VIEWING', response.data);

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
};
